import React, { useState, useEffect } from 'react';
import api from '../../../../services/api';

const PermissionList = ({ refresh, onPermissionDeleted }) => {
    const [permissions, setPermissions] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(null);

    useEffect(() => {
        const fetchPermissions = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await api.get('/roles/permissions');
                  if (response && response.data) {
                      setPermissions(response.data);
                  } else {
                       setError('Неправильный формат данных с сервера: некорректные данные');
                   }
            } catch (err) {
                console.error('Ошибка при загрузке прав:', err);
                setError('Ошибка при загрузке прав: ' + err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPermissions();
    }, [refresh]);

    const handlePermissionDelete = async (permissionId) => {
        if (window.confirm('Вы действительно хотите удалить это право?')) {
            setDeleteLoading(permissionId);
            setError(null);

            console.log("Начало запроса удаления:", permissionId);

           try {
                const response = await api.delete(`/roles/permissions/${permissionId}`);
                console.log("Ответ получен:", response, permissionId);


                 if (response) {
                   try {
                        const data = typeof response === 'string' ? JSON.parse(response) : (response.data ? (typeof response.data === 'string' ? JSON.parse(response.data) : response.data) : response);

                        console.log("Распарсенные данные:", data, permissionId);

                        if (data && data.status === "success") {
                             console.log('Право успешно удалено:', permissionId);
                             setPermissions(prevPermissions => prevPermissions.filter(permission => permission.id !== permissionId));
                             if (onPermissionDeleted) {
                                  onPermissionDeleted();
                             }
                        } else {
                          console.error('Ошибка при удалении права, код:', data ? JSON.stringify(data) : 'нет ответа' , permissionId);
                          setError(`Ошибка при удалении права: ${data ?  JSON.stringify(data) : 'нет ответа'}`);
                       }
                    } catch (parseError) {
                       console.error('Ошибка при парсинге JSON:', response, parseError)
                       setError('Ошибка при парсинге JSON: ' + parseError.message);
                   }
                 } else {
                   console.error('Ошибка при удалении права, нет response', permissionId);
                   setError('Ошибка при удалении права, нет response');
                }

            } catch (error) {
               console.error('Ошибка при удалении права:', error);
               setError('Ошибка при удалении права: ' + error.message);
           } finally {
               setDeleteLoading(null);
           }
       }
   };


   if (loading) {
       return <div>Загрузка прав...</div>;
   }

   if (error) {
       return <div className="error-message">{error}</div>;
   }

   return (
       <ul className="permission-list">
           {permissions &&
               permissions.map((permission) => (
                   <li key={permission.id} className="permission-item">
                       <span style={{ marginRight: '10px' }}>{permission.name}</span>
                         <button
                             onClick={() => handlePermissionDelete(permission.id)}
                             className="delete-button"
                             disabled={deleteLoading === permission.id}
                         >
                             {deleteLoading === permission.id ? 'Удаление...' : 'Удалить'}
                         </button>
                   </li>
               ))}
       </ul>
   );
};

export default PermissionList;
